<template>
	<span>{{ representation }}</span>
</template>

<script>
export default {
	name: 'ArgDate',
	props: {value: Object},
	computed: {
		representation() {
			if (this.value.data['@t'] === '[[NaN]]') return ''
			return new Date(this.value.data).toISOString()
		},
	},
}
</script>
